/** Kill switch for the All Reports redesign: false restores the TA-only listing. */
export const PARTNER_CONSOLIDATED_REPORTS_FLAG = 'partnerConsolidatedReports';
